import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import includes from 'lodash/includes';
import { Link } from 'react-scroll';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
} from '@fortawesome/free-brands-svg-icons';

import { currencyCode } from 'Helpers/Geo/data';
import ProductCover from 'Components/Utility/ProductCover';
import Price from 'Components/Utility/Price/Price';
import Drm from 'Components/Utility/Drm';

export default function BundleProductMegaCard({
  bestEverPrice,
  product,
  switchCarouselGame,
}) {
  let productDownloads = [];
  if (product.downloads) {
    productDownloads = product.downloads.filter(
      download => !download.is_sample && !download.is_group,
    );
  }

  const downloadTypes = [];
  productDownloads.forEach((download) => {
    download.files.forEach((file) => {
      if (includes(downloadTypes, file.format)) {
        return;
      }
      downloadTypes.push(file.format);
    });
  });

  const validDrm = Object.keys(product.drm || {}).filter(d => product.drm[d]);

  let extraGameDescription = false;
  if (product.customDesc && window.locale === 'en') {
    extraGameDescription = true;
  }

  return (
    <article
      className={classNames(
        'bundle-product-card bundle-product-mega-card',
        { 'card-extra-info': extraGameDescription },
        'faux-block-link',
      )}
    >
      {product.type === 'dlc' &&
        <div className="card-label dlc-label">
          <div className="label-container">
            <div className="label-content">
              <FormattedMessage id="bundle-product-mega-card.label.dlc" defaultMessage="DLC" />
            </div>
            <div className="label-slash" />
          </div>
          <div className="label-triangle triangle-dlc" />
        </div>
      }

      {bestEverPrice &&
        <div className="card-label bestever-label">
          <div className="label-container">
            <div className="label-content">
              <FormattedMessage id="bundle-product-mega-card.label.bestever" defaultMessage="Best Ever Price" />
            </div>
            <div className="label-slash" />
          </div>
          <div className="label-triangle triangle-bestever" />
        </div>
      }

      <div className="image-content-container">
        <ProductCover
          lazy={false}
          cover={product.cover}
          alt={`Product cover for ${product.name}`}
          displayType={product.display_type}
          sizesOverride="(min-width: 1520px) 662px, (min-width: 1200px) 562px, (min-width: 992px) 472px, (min-width: 768px) 352px, (min-width: 576px) 524px, 50vw"
        />

        <div className="card-content-container">
          <div className="name-details-container">
            <h3 className="mega-product-name">{product.name}</h3>
            {extraGameDescription &&
              <p className="description">{product.customDesc}</p>
            }
            {!extraGameDescription && product.seo && product.seo.desc &&
              <p className="description">{product.seo.desc}</p>
            }
            <Link
              spy
              smooth
              offset={-120}
              activeClass="active"
              to="carousel"
              duration={500}
              className="faux-block-link__overlay-link"
              onClick={() => { switchCarouselGame(product.totalGameIndex); }}
            >
              <p className="product-details">
                <FormattedMessage id="bundle-product-mega-card.detailslink" defaultMessage="Product details" />
              </p>
            </Link>
          </div>

          {extraGameDescription &&
            <div className="description d-md-none">
              <p>{product.customDesc}</p>
            </div>
          }

          <div className="card-icons-price-container">
            <div className="platform-container">
              {product.platforms && product.platforms.windows &&
                <span>
                  <FontAwesomeIcon icon={fabFaWindows} className="mr-2" />
                </span>
              }
              {product.platforms && product.platforms.mac &&
                <span>
                  <FontAwesomeIcon icon={fabFaApple} className="mr-2" />
                </span>
              }
              {product.platforms && product.platforms.linux &&
                <span>
                  <FontAwesomeIcon icon={fabFaLinux} className="mr-2" />
                </span>
              }
            </div>
            <Drm drmType={validDrm[0]} />

            {product.price && product.price[currencyCode] !== 0 &&
              <div className="game-price">
                <p>
                  <FormattedMessage id="bundle-product-mega-card.value" defaultMessage="Value:" />
                  &nbsp;
                  <Price
                    price={product.price}
                  />
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </article>
  );
}

BundleProductMegaCard.propTypes = {
  bestEverPrice: PropTypes.bool,
  product: PropTypes.shape({}),
  switchCarouselGame: PropTypes.func,
};

BundleProductMegaCard.defaultProps = {
  bestEverPrice: false,
  product: {},
  switchCarouselGame: () => { },
};
